/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button } from '@atoms';
import { useModalControls } from '@hooks';

import SortableArrayField from '../SortableArrayField';

import LanguageItem from './LanguageItem';
import LanguageModal from './LanguageModal';

const LanguagesList = ({ field, form, eventId, title, okText, titleLevel }) => {
  const modalControls = useModalControls(false);

  const handleAddLanguage = async ({ code }) => {
    // can be undefined if only tag was saved to API
    const languageCodes = form.getFieldValue(field.name) || [];
    form.setFieldsValue({ [field.name]: [...languageCodes, code] });
  };

  return (
    <>
      <SortableArrayField
        {...field}
        withPlaceholder
        titleLevel={3}
        extra={<Button onClick={modalControls.show}>CHOOSE A LANGUAGE</Button>}
        titleStyle={{ marginBottom: 30 }}
      >
        {(code) => <LanguageItem code={code} />}
      </SortableArrayField>
      <LanguageModal
        {...modalControls}
        eventId={eventId}
        onSubmit={handleAddLanguage}
        title={title}
        titleLevel={titleLevel}
        okText={okText}
      />
    </>
  );
};

export default LanguagesList;
